module.exports = __webpack_public_path__ + "img/happy-kids-home-03.7fc78a4.svg";